import { IConsumptionGlobalSummaryDTO } from "@/interface"
import { ConsumptionSummaryUnitEnum, ConsumptionSummaryTypeEnum } from "@/enums"

export class UnitValueBalance {
    value: number;
    unit: ConsumptionSummaryUnitEnum | null;
    balanceValue: number;
    balanceUnit: ConsumptionSummaryUnitEnum | null;
    overspentValue?: number;
    overspentUnit?: ConsumptionSummaryUnitEnum | null;

    constructor(base?: Partial<UnitValueBalance>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IConsumptionGlobalSummaryDTO, key: ConsumptionSummaryTypeEnum) {
        if (!dto) {
            return dto;
        }
        return new UnitValueBalance({
            value: +dto.cdrUsage[key].value,
            unit: dto.cdrUsage[key].unit ? dto.cdrUsage[key].unit : null,
            balanceValue: +dto.balances[key].value,
            balanceUnit: dto.balances[key].unit ? dto.balances[key].unit : null,
            overspentValue: dto.cdrUsage[key]?.overspent_value,
            overspentUnit: dto.cdrUsage[key].overspent_unit ? dto.balances[key].overspent_unit : null,
        });
    }
}
